export default "__VITE_ASSET__DsUfHuuM__"